import { render } from "./f-requests.vue?vue&type=template&id=7a0e8e14"
import script from "./f-requests.vue?vue&type=script&lang=js"
export * from "./f-requests.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__